import type { FC } from 'react';

import { Callout } from '@crehana/compass.ui';
import { useTranslation } from '@crehana/i18n';

import SkeletonAnimated from '../SkeletonAnimated';

const DASHBOARD_UPDATE_DELAY_AVG_DAYS = 0;

const today = new Date();
today.setDate(today.getDate() - DASHBOARD_UPDATE_DELAY_AVG_DAYS);

interface LastUpdateProps {
  isLoading?: boolean;
}

const LastUpdate: FC<LastUpdateProps> = ({ isLoading }) => {
  const { t, languageCode } = useTranslation();

  if (isLoading) {
    return <SkeletonAnimated className="w-280 h-20" />;
  }

  return (
    <Callout
      type="informative"
      title={t('LAST_UPDATE_GENERAL', {
        interpolation: {
          date: today.toLocaleDateString(languageCode, {
            month: 'long',
            day: 'numeric',
            timeZone: 'UTC',
          }),
        },
      })}
      subtitle={t('LAST_UPDATE_GENERAL_DESC')}
      className="tw-flex tw-h-full tw-relative"
    />
  );
};

export default LastUpdate;
